<template>
  <div class="main">
    <van-form @submit="onSubmit" label-width="80" style="padding: 8px 24px">
      <van-field label="姓名" v-model="form.Name" readonly />
      <van-field label="工号" v-model="form.UserId" readonly />
      <van-field label="联系方式 " v-model="form.Phone" clearable :rules="[{ required: true }]" />
      <van-field
        v-model="form.Message"
        rows="3"
        autosize
        label="留言"
        type="textarea"
        maxlength="200"
        placeholder="请输入留言"
        show-word-limit
        :rules="[{ required: true }]"
      />
      <div style="margin-top: 20px;">
        <van-button round block color="#FEB013" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        Name: '',
        UserId: '',
        Phone: '',
        Message: '',
        Status: false
      }
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
  },
  methods: {
    async onSubmit() {
      console.log('onSubmit()')
      const result = await this.postFeedBack(this.form)
      if (result.success) {
        this.$toast('提交成功')
        this.$router.push('/home')
      } else {
        this.$toast(result.message)
      }
    },
    postFeedBack(data) {
      return this.$request({
        url: this.$api.postFeedBack,
        method: 'POST',
        params: {},
        data
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    height: inherit;
    background-color:#FFFFFF;
  }
  /deep/.van-cell {
    background-color: #F5F5F5;
    margin: 8px 0;
    border-radius: 4px;
    padding: 16px 12px;
    font-size: 16px;
  }
</style>
